// pages/About.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .about-page > div:first-child {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .about-page h1 {
              font-size: 2.5rem !important;
            }
            .about-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>

        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات
        </h1>

        <h3 style={{
          fontSize: '2rem',
          marginBottom: '20px',
          fontWeight: '600',
          lineHeight: '1.6'
        }}>
        جائحة رقمية صامتة تهدد المجتمع
        </h3>

        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginBottom: '25px'
        }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
          <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>التاريخ:</strong> 25 نونبر – 10 دجنبر 2025
          </p>
          <p style={{ fontSize: '1.3rem' }}>
            <img src="/images/duration.png" className="tab-icon3-img" /> <strong>المدة:</strong> 16 يوما
          </p>
        </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">
          {/* Campaign Introduction */}
          <div style={{
            background: 'var(--primary-black)',
            padding: '50px 40px',
            borderRadius: '20px',
            marginBottom: '50px',
            border: '2px solid rgba(255, 107, 53, 0.3)'
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--primary-orange)',
              textAlign: 'center'
            }}>
              جائحة رقمية صامتة تهدد المجتمع
            </h2>

            <div style={{
              fontSize: '1.2rem',
              lineHeight: '2',
              color: 'var(--text-light)'
            }}>

            <p style={{ marginBottom: '20px' }}>
        العنف ضد النساء والفتيات <strong style={{ color: 'var(--primary-orange)' }}>أكثر انتهاكات حقوق الإنسان انتشارا في العالم</strong>. تتعرض امرأة من كل ثلاث نساء لنوع من أنواعه، مرة واحدة في حياتها على الأقل.
      </p>

      <p style={{ marginBottom: '20px' }}>
        مع التطور المتسارع للتكنولوجيات الحديثة ووسائل التواصل الاجتماعي، <strong style={{ color: 'var(--primary-orange)' }}>توسّعت رقعة العنف ضد النساء والفتيات</strong> لتأخذ أشكالًا رقمية جديدة أكثر تعقيدا، حيث أصبحت التكنولوجيا تُيسّر هذا العنف وتضاعف أثره النفسي والاجتماعي والقانوني.
      </p>

            </div>
          </div>

          {/* Alarming Statistics */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              معطيات عالمية مقلقة
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  16-58%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  نسبة انتشار العنف الرقمي عالميا
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  14-16
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
              السن الذي يبدأ فيه تعرض الفتيات للتحرش الإلكتروني
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  من النساء في المنطقة العربية يتعرضن لأشكال من العنف الرقمي
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  95%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  من محتوى "التزييف العميق" الإباحي يستهدف النساء
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  من حالات العنف الرقمي بالمنطقة العربية تنتقل إلى العنف الواقعي
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  امرأة مغربية تتعرض للعنف الرقمي سنويا
                </p>
              </div>
            </div>
          </div>

          {/* Most Common Forms */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              أكثر أشكال العنف الرقمي انتشارا
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px'
            }}>
              {[
                { percentage: '67%', text: 'التشهير ونشر المعلومات الكاذبة' },
                { percentage: '66%', text: 'التحرش الإلكتروني' },
                { percentage: '65%', text: 'خطاب الكراهية' }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  textAlign: 'center',
                  border: '2px solid rgba(255, 107, 53, 0.3)'
                }}>
                  <div style={{
                    fontSize: '3rem',
                    fontWeight: '700',
                    color: 'var(--primary-orange)',
                    marginBottom: '15px'
                  }}>
                    {item.percentage}
                  </div>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px',
              marginTop: '25px'
            }}>
              {[
                'التنمر والابتزاز الإلكتروني',
                'الاتجار بالبشر الإلكتروني',
                'التزييف العميق بالذكاء الاصطناعي'
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  textAlign: 'center',
                  border: '2px solid rgba(255, 107, 53, 0.3)'
                }}>
                  <p style={{ fontSize: '1.2rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Situation in Morocco */}
          <div style={{ marginTop: '60px', marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              الوضع في المغرب
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px'
            }}>
              {/* Most Vulnerable Groups */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)'
                }}>
                  الفئات الأكثر عرضة للعنف الرقمي
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• النساء في المناطق الحضرية: <strong>16%</strong></p>
                  <p style={{ marginBottom: '10px' }}>• الفتيات بين 15 و19 سنة: <strong>29%</strong></p>
                  <p style={{ marginBottom: '10px' }}>• النساء ذوات المستوى التعليمي العالي: <strong>25%</strong></p>
                  <p style={{ marginBottom: '10px' }}>• العازبات: <strong>30%</strong></p>
                  <p>• الطالبات: <strong>36%</strong></p>
                </div>
              </div>

              {/* Perpetrators Identity */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)'
                }}>
                  هوية المعتدين
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• <strong>73%</strong> رجال مجهولو الهوية</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> شركاء حاليون أو سابقون</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> أفراد من العائلة</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> زملاء في الدراسة أو العمل</p>
                  <p>• <strong>4%</strong> أصدقاء</p>
                </div>
              </div>

              {/* Reporting Problem */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)'
                }}>
                  إشكالية التبليغ
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      11%
                    </div>
                    <p>فقط من الصحفيات يبلغن عن العنف الرقمي</p>
                  </div>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      8%
                    </div>
                    <p>فقط يتخذن إجراءات قانونية</p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 133, 85, 0.08))',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              textAlign: 'center',
              marginTop: '30px'
            }}>
              <p style={{ fontSize: '1.3rem', lineHeight: '2', color: 'var(--text-light)' }}>
              تزداد الهجمات الرقمية حدةً ضد النساء ذوات الحضور البارز في الفضاء العام، خصوصا المنخرطات في المجالات الإعلامية والسياسية والحقوقية. وتشمل هذه الاعتداءات <strong style={{ color: 'var(--primary-orange)' }}>التشهير، التهديد، التمييز، العنف اللفظي، التحرش، والعنف الجنسي</strong>؛ وهي اعتداءات تمس حق النساء في حرية التعبير والمشاركة في الحياة العامة.
              </p>
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Campaign Organizer */}
          <div style={{ marginTop: '60px', marginBottom: '60px' }}>


            <div style={{
              background: 'var(--primary-black)',
              padding: '50px 40px',
              borderRadius: '20px',
              border: '2px solid var(--primary-orange)'
            }}>
              <h4 style={{
                fontSize: '2.2rem',
                marginBottom: '25px',
                color: 'var(--primary-orange)',
                textAlign: 'center'
              }}>
                مانسكتوش على العنف 2025
              </h4>

              <div style={{
    fontSize: '1.15rem',
    lineHeight: '2',
    color: 'var(--text-light)',
    justifySelf: 'center'
  }}>

              <p style={{ marginBottom: '20px' }}>
  حملة وطنية أخرى يطلقها <strong style={{ color: 'var(--primary-orange)' }}>المجلس الوطني لحقوق الإنسان</strong> لمناهضة العنف ضد النساء والفتيات.
</p>


                <p>
                حملة تجوب جهات المملكة للتحسيس بالعنف الذي تيسره التكنولوجيا ضد النساء والفتيات.
                </p>
                <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.3rem', color: 'var(--primary-orange)' }}>
                  <strong>25 نونبر – 10 دجنبر</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Campaign Objectives */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              أهداف الحملة
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'ترسيخ الحماية',
                  desc: 'التعبئة لحماية حقوق النساء والفتيات في الفضاء الرقمي وعصر الذكاء الاصطناعي'
                },
                {
                  icon: '📚',
                  title: 'التعريف والوقاية',
                  desc: 'رفع الوعي بمخاطر التكنولوجيا الميسّرة للعنف، وتقديم سبل الوقاية منه'
                },
                {
                  icon: '🔔',
                  title: 'التحسيس والتوعية',
                  desc: 'ترسيخ ثقافة السلامة الرقمية وأمن الإنترنت والتكنولوجيا'
                },
                {
                  icon: '🔊',
                  title: 'التبليغ وكسر الصمت',
                  desc: 'دعم ضحايا العنف الرقمي لكسر جدار الخوف والصمت والنشجيع على التبليغ'
                }
              ].map((objective, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '35px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ fontSize: '3.5rem', marginBottom: '20px' }}>{objective.icon}</div>
                  <h4 style={{
                    fontSize: '1.6rem',
                    marginBottom: '15px',
                    color: 'var(--primary-orange)'
                  }}>
                    {objective.title}
                  </h4>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                    {objective.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
              مرحبا بكن/م في محطات الحملة
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8'
            }}>
              نرحب بانضمامكن/م إلى هذه الحملة، وننتظر تفاعلاتكن/م واقتراحاتكن/م للمساهمة في فضاء رقمي آمن وعادل للجميع.
            </p>

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '20px'
            }}>


            </div>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '40px',
              color: 'var(--text-light)',
              fontStyle: 'italic'
            }}>
            معاً نكسر جدار الصمت | معاً نقف في وجه الجائحة الرقمية الصامتة
            </p>
          </div>


        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default About;
